export const config = {
  title: "Home Remodeling & Landscaping LLC",
  meta: {
    description:
      "Home Remodeling & Landscaping LLC offers kitchen & bathroom remodels, basement finishing, custom decks, flooring, painting, siding, masonry, and lawn & hardscaping in Annapolis, MD.",
    keywords: [
      "Home Remodeling Annapolis",
      "Landscaping Annapolis MD",
      "Kitchen bathroom remodel Annapolis",
      "Deck and porch builders Annapolis",
      "Basement finishing Annapolis"
    ],
    author: "Home Remodeling & Landscaping LLC",
    canonicalUrl: "https://homeremodeling-llc.com/",
  },
  sections: {
    header: { businessName: "Home Remodeling & Landscaping LLC" },
    sectionB: {
      heroTitle: "Home Remodeling & Landscaping LLC",
      heroSubtitle: "Transforming Homes & Outdoor Spaces in Annapolis, MD",
      learnAboutText: "Explore Our Services",
      phoneNumber: "4437639630",
      phoneLabel: "(443) 763‑9630",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2155337506/photo/suburban-gardens.jpg?s=612x612&w=0&k=20&c=KkloGZv15Cw6LFrf4iOtkReynbj4wu5lw6tgRerpKto=",
      cardData: [
        {
          title: "Kitchen & Bathroom Remodel",
          description: "Custom cabinetry, tile, fixtures, and flooring.",
        },
        {
          title: "Basement Finishing & Decks",
          description: "Create functional living spaces and outdoor decks.",
        },
        {
          title: "Landscaping & Hardscaping",
          description: "Walkways, pavers, stone beds, lawn care, mulch & more.",
        },
      ],
      description:
        "Serving Annapolis and surrounding areas, Home Remodeling & Landscaping LLC specializes in home interior remodeling—kitchens, baths, basements—and exterior landscaping, decks, lawns and hardscaping with licensed and insured craftsmanship.",
    },
    sectionC: {
      servicesTitle: "What We Do",
      servicesDescription:
        "From interior renovations to outdoor transformations—expertly executed with attention to detail.",
      cards: [
        {
          title: "Remodel & Carpentry",
          description: "Painting, drywall, flooring, siding and custom carpentry.",
          imageSrc: "https://media.istockphoto.com/id/1409967798/photo/carpenter-arranging-and-measuring-planks.jpg?s=612x612&w=0&k=20&c=zo4-o2FH0GrbE7nVXxf33BgorQJL91V4IENcQ2T-fEI=",
          imageAlt: "Remodeling Carpentry",
        },
        {
          title: "Decks & Porches",
          description: "Custom deck and porch construction and repair.",
          imageSrc: "https://media.istockphoto.com/id/2197110293/photo/wooden-outside-deck-construction-in-progress.jpg?s=612x612&w=0&k=20&c=AS41JEzv3HmjYpSIIAgqF9dR5X_y73JHwiIjVR2bWEI=",
          imageAlt: "Deck Builders",
        },
        {
          title: "Landscaping Services",
          description: "Masonry, pavers, walkways, lawn care, stone accents.",
          imageSrc: "https://media.istockphoto.com/id/1315346350/photo/beautiful-english-cottage-garden-colorful-flowering-plant-on-smooth-green-grass-lawn-and.jpg?s=612x612&w=0&k=20&c=zngYIc6K9Ucx21OlFbfqBAO_i9zAFjUzVnmBVUqR8uQ=",
          imageAlt: "Landscaping Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Tile & Flooring",
        "Interior & Exterior Painting",
        "Drywall & Siding Repair",
        "Mulching & Lawn Maintenance",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://homeremodeling-llc.com/wp-content/uploads/2024/11/sd-11.png",
        alt: "Remodeling Team",
      },
      aboutText: [
        "Home Remodeling & Landscaping LLC has over 10 years of experience serving Annapolis, MD, with licensed and insured remodeling and landscaping services.",
        "We prioritize attention to detail, timely completion, free estimates, and bilingual (Spanish) customer support.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Home Remodeling & Landscaping Logo",
      businessName: "Home Remodeling & Landscaping LLC",
      contact: {
        phone: "4437639630",
        phoneLabel: "(443) 763‑9630",
        email: "bautistaleonel389@gmail.com",
        website: "https://homeremodeling-llc.com/",
        address: "Annapolis, MD (Serving Annapolis & Nearby Areas)",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "Annapolis, MD",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3542.123456789!2d-76.492!3d38.978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sAnnapolis%2C+MD!5e0!3m2!1sen!2sus!4v1718740000000!5m2!1sen!2sus",
    },
  },
};

export default config;
